module.exports = function() {
  return new Worker(__webpack_public_path__ + "pdfExports.a31bd645423bcefd2860.js");
};